import { render, staticRenderFns } from "./add_menu_dialog.vue?vue&type=template&id=d2e58ff8&scoped=true"
import script from "./add_menu_dialog.vue?vue&type=script&lang=js"
export * from "./add_menu_dialog.vue?vue&type=script&lang=js"
import style0 from "./add_menu_dialog.vue?vue&type=style&index=0&id=d2e58ff8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e58ff8",
  null
  
)

export default component.exports